import {
  Icon,
  ProviderConnectionStatus,
  renderProviderConnectionStatusIcon,
  renderProviderConnectionStatusName,
  TooltipWrapper,
} from '@vgrubs/components';

export const ProviderConnectionStatusComponent = ({
  status,
}: {
  status: ProviderConnectionStatus;
}) => {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      style={{ height: '24px', width: '24px' }}
    >
      <TooltipWrapper tooltip={renderProviderConnectionStatusName(status)}>
        <Icon>{renderProviderConnectionStatusIcon(status)}</Icon>
      </TooltipWrapper>
    </div>
  );
};
